'use client';

import {
  RETENTION_DESKTOP_CTA_LABEL,
  RETENTION_TITLE,
  dismissRetentionNotification,
  getRetentionNotificationMessage,
} from '@/components/Form/CancellationRetention/cancellationRetentionHelper';
import { useCancellationRetentionCtaClick } from '@/components/Form/CancellationRetention/useCancellationRetentionTracking';
import Popup from '@/components/Popup/Popup';
import type { GlobalProjectSettingsStoryblok } from '@/types/component-types-sb';
import { type FC, useCallback } from 'react';

type CancellationRetentionNotificationProps = {
  settings?: GlobalProjectSettingsStoryblok | null;
  loggedIn: boolean;
  salutation?: string;
  lastname?: string;
  onDismiss: () => void;
  open: boolean;
};

const CancellationRetentionNotification: FC<CancellationRetentionNotificationProps> = ({
  settings,
  loggedIn,
  salutation,
  lastname,
  onDismiss,
  open,
}) => {
  const message = getRetentionNotificationMessage(loggedIn, salutation, lastname);
  const handleCtaClick = useCancellationRetentionCtaClick(settings, RETENTION_DESKTOP_CTA_LABEL);

  const handleClose = useCallback(() => {
    dismissRetentionNotification();
    onDismiss();
  }, [onDismiss]);

  return (
    <Popup
      open={open}
      onClose={handleClose}
      title={RETENTION_TITLE}
      text={message}
      ctaText={RETENTION_DESKTOP_CTA_LABEL}
      onCtaClick={handleCtaClick}
    />
  );
};

export default CancellationRetentionNotification;
